<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >{{ data.servicio.descripcion }}
                {{ data.servicio.atributos.join(", ") }}</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formAgregarServicio" autocomplete="off">
            <mat-form-field class="full-width">
                <mat-label>Cantidad </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="cantidad"
                    [required]="data.servicio.unidadMedida"
                />
                <span matSuffix>
                    <span>
                        {{ data.servicio.unidadMedida?.descripcion }}
                    </span>
                </span>

                <mat-error *ngIf="cantidad.hasError('required')">
                    Debe ingresar la cantidad
                </mat-error>
                <mat-error *ngIf="cantidad.hasError('max')">
                    La cantidad no puede ser mayor a 50.000.000
                </mat-error>
                <mat-error *ngIf="cantidad.hasError('min')">
                    La cantidad no puede ser menor a 0
                </mat-error>
                <mat-error *ngIf="cantidad.hasError('pattern')">
                    Debe ingresar un valor numérico
                </mat-error>
            </mat-form-field>
            <mat-form-field
                class="full-width"
                *ngIf="data.servicio.unidadTiempo"
            >
                <mat-label>Tiempo </mat-label>
                <input
                    matInput
                    type="number"
                    formControlName="tiempo"
                    [required]="data.servicio.unidadTiempo"
                />
                <span matSuffix>
                    <span> {{ data.servicio.unidadTiempo?.descripcion }} </span>
                </span>

                <mat-error *ngIf="tiempo.hasError('required')">
                    Debe ingresar el tiempo
                </mat-error>
                <mat-error *ngIf="tiempo.hasError('max')">
                    La cantidad no puede ser mayor a 50.000.000
                </mat-error>
                <mat-error *ngIf="tiempo.hasError('min')">
                    La cantidad no puede ser menor a 0
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Condición</mat-label>
                <mat-select formControlName="condicion" required>
                    <mat-option *ngFor="let c of condiciones" [value]="c.id">
                        {{ c.descripcion }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="condicion.hasError('required')">
                    Debe seleccionar una condición
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Observaciones</mat-label>
                <textarea
                    matInput
                    formControlName="observacion"
                    required
                    rows="3"
                    placeholder="Observaciones relacionadas al servicio"
                ></textarea>
                <mat-hint
                    >{{ observacion.value?.length }} /
                    {{ largoMaximo }}</mat-hint
                >
                <mat-error *ngIf="observacion.hasError('required')">
                    Debe ingresar una observación
                </mat-error>
                <mat-error *ngIf="observacion.hasError('maxlength')">
                    La observacion no puede ser mayor a 500 caracteres
                </mat-error>
                <!-- mat-error *ngIf="observacion.hasError('minlength')">
                    Debe ingresar al menos
                    {{ observacion.getError("minlength").requiredLength }}
                    caracteres
                </mat-error>
                <mat-error *ngIf="observacion.hasError('maxlength')">
                    Máximo
                    {{ observacion.getError("maxlength").requiredLength }}
                    caracteres
                </mat-error -->
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formAgregarServicio.value"
            [disabled]="!formAgregarServicio.valid"
        >
            Agregar
        </button>
    </mat-dialog-actions>
</div>
